// extracted by mini-css-extract-plugin
export default {"StudyPageInfoBox":"upySpT3En7Nr6Lw3amEi","Content":"gLMf1nRmaQLxziVqxFTg"};